import script from "./ProjectNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectNavigation.vue?vue&type=style&index=0&id=119e5ce3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-119e5ce3"]])

export default __exports__